import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {  useNavigate } from 'react-router-dom';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { getCaInfo,getUserAfterMintInfo ,backUFun3,backUFun2,backUFun1,getTFun1,getTFun2,getTFun3} from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getTuanInfo, register,login} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const AfterSale = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)

    const [ca, setCa] = useState("");
    const [mintAmount, setMintAmount] = useState("");
    const [mintBeginTime, setMintBeginTime] = useState("");
    const [mintState, setMintState] = useState("");
    const [mintTotalAddress, setMintTotalAddress] = useState("");
    const [mintTotalAmount, setMintTotalAmount] = useState("");
    const [tokenPrice, setTokenPrice] = useState("");

    const [isBackU1, setIsBackU1] = useState("");
    const [isBackU2, setIsBackU2] = useState("");
    const [isBackU3, setIsBackU3] = useState("");

    const [isGetT1, setIsGetT1] = useState("");
    const [isGetT2, setIsGetT2] = useState("");
    const [isGetT3, setIsGetT3] = useState("");

    const [usdtAmount1, setUsdtAmount1] = useState("");
    const [usdtAmount2, setUsdtAmount2] = useState("");
    const [usdtAmount3, setUsdtAmount3] = useState("");

    const [backUNum1, setBackUNum1] = useState("");
    const [backUNum2, setBackUNum2] = useState("");
    const [backUNum3, setBackUNum3] = useState("");

    const [getTNum1, setGetTNum1] = useState("");
    const [getTNum2, setGetTNum2] = useState("");
    const [getTNum3, setGetTNum3] = useState("");



   


    const navigate = useNavigate()//hook事件路由跳转
    
    
    

    

    
 

    const _randUsdt1 = () =>{
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(backUNum1==0){
            message.error(t('mint.暂未开始领取!'))
            return false
        }
        if(usdtAmount1 == 0 ||usdtAmount1.length ==0){
            message.error(t('mint.本期您未参与!'))
            return false
        }
        if(isBackU1){
            message.error(t('mint.您已领取过!'))
            return false
        }
       

        message.warning(t('mint.发起中请等待'),4)
        
             backUFun1().then(res1=>{
                    message.success(t('air.领取成功'))
                    setNum(num+1)
                    return false
                },err=>{
                    message.error(t('mint.操作已取消'))
                    return false
                })
    } 

    const _randUsdt2 = () =>{
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(backUNum2==0){
            message.error(t('mint.暂未开始领取!'))
            return false
        }
        if(usdtAmount2 == 0 ||usdtAmount2.length ==0){
            message.error(t('mint.本期您未参与!'))
            return false
        }
        if(isBackU2){
            message.error(t('mint.您已领取过!'))
            return false
        }
       

        message.warning(t('mint.发起中请等待'),4)
        
             backUFun2().then(res1=>{
                    message.success(t('air.领取成功'))
                    setNum(num+1)
                    return false
                },err=>{
                    message.error(t('mint.操作已取消'))
                    return false
                })
    } 

    const _randUsdt3 = () =>{
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(backUNum3==0){
            message.error(t('mint.暂未开始领取!'))
            return false
        }
        if(usdtAmount3 == 0 ||usdtAmount3.length ==0){
            message.error(t('mint.本期您未参与!'))
            return false
        }
        if(isBackU3){
            message.error(t('mint.您已领取过!'))
            return false
        }
       

        message.warning(t('mint.发起中请等待'),4)
        
             backUFun3().then(res1=>{
                    message.success(t('air.领取成功'))
                    setNum(num+1)
                    return false
                },err=>{
                    message.error(t('mint.操作已取消'))
                    return false
                })
    } 


    const _randT1 = () =>{
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(getTNum1==0){
            message.error(t('mint.暂未开始领取!'))
            return false
        }
        if(usdtAmount1 == 0 ||usdtAmount1.length ==0){
            message.error(t('mint.本期您未参与!'))
            return false
        }
        if(isGetT1){
            message.error(t('mint.您已领取过!'))
            return false
        }
       

        message.warning(t('mint.发起中请等待'),4)
        
             getTFun1().then(res1=>{
                    message.success(t('air.领取成功'))
                    setNum(num+1)
                    return false
                },err=>{
                    message.error(t('mint.操作已取消'))
                    return false
                })
    }

    const _randT2 = () =>{
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(getTNum2==0){
            message.error(t('mint.暂未开始领取!'))
            return false
        }
        if(usdtAmount2 == 0 ||usdtAmount2.length ==0){
            message.error(t('mint.本期您未参与!'))
            return false
        }
        if(isGetT2){
            message.error(t('mint.您已领取过!'))
            return false
        }
       

        message.warning(t('mint.发起中请等待'),4)
        
             getTFun2().then(res1=>{
                    message.success(t('air.领取成功'))
                    setNum(num+1)
                    return false
                },err=>{
                    message.error(t('mint.操作已取消'))
                    return false
                })
    }


    const _randT3 = () =>{
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(getTNum3==0){
            message.error(t('mint.暂未开始领取!'))
            return false
        }
        if(usdtAmount3 == 0 ||usdtAmount3.length ==0){
            message.error(t('mint.本期您未参与!'))
            return false
        }
        if(isGetT3){
            message.error(t('mint.您已领取过!'))
            return false
        }
       

        message.warning(t('mint.发起中请等待'),4)
        
             getTFun3().then(res1=>{
                    message.success(t('air.领取成功'))
                    setNum(num+1)
                    return false
                },err=>{
                    message.error(t('mint.操作已取消'))
                    return false
                })
    } 


    const _getUserAfterMintInfo = () =>{
        if(props.address.length<=0 ){
                    
                                return false
                }
        getUserAfterMintInfo(props.address).then(res=>{
            
            setIsBackU1(res.isBackU1)
            setIsBackU2(res.isBackU2)
            setIsBackU3(res.isBackU3)
            setIsGetT1(res.isGetT1)
            setIsGetT2(res.isGetT2)
            setIsGetT3(res.isGetT3)

            setUsdtAmount1(res.usdtAmount1)
            setUsdtAmount2(res.usdtAmount2)
            setUsdtAmount3(res.usdtAmount3)

            setBackUNum1(res.backUNum1)
            setBackUNum2(res.backUNum2)
            setBackUNum3(res.backUNum3)

            setGetTNum1(res.getTNum1)
            setGetTNum2(res.getTNum2)
            setGetTNum3(res.getTNum3)        
          
        })
    }
   




    useEffect(() => {
        // window.scrollTo(0, 0)
        _getUserAfterMintInfo()
            //_getCaInfo()
            
            //_getTuanInfo()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
            <Head/>
            

            
            
            <div style={{"backgroundColor":"#0D0918"}} className='indexBg33  w-full lg:w-1/3 h-screen overflow-hidden pt-16'>
                <main className="h-full overflow-auto  ">
                {/*  */}
                <div onClick={()=>window.history.back()} className='w-full px-2   '>
                    <div className='mt-2 w-full h-12  flex flex-row justify-start items-center'>
                        <img alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                        <span className='text-lg oblod text-gray-100'>{t('mint.认购结算')}</span>
                    </div>
                   
                </div>
                <div className='px-4 text-[11px] text-pink-500'>
                    *{t('mint.单个钱包最大认购数量100USDT，未认购成功的USDT会原路退回')}
                </div>

                <div className='w-full px-4 mt-6 flex flex-row justify-between items-center'>
                    <span className='text-white text-sm'>{t('mint.当前期数')}：1</span>
                    <span className='text-[#E94B6C] text-sm font-bold'>BNB chain main</span>
                </div>

                {/*  */}
                <div className='  mt-2 mb-9 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>


                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.我已认购金额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{usdtAmount1} USDT</span>
                           
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.退USDT数量')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{backUNum1} USDT</span>
                           
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.可领取代币数量')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{getTNum1} VRP</span>
                           
                        </div>
                    </div>
                   
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>
                    
                    
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_randUsdt1}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.领取退U')}</span></button>
                    </div>

                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_randT1}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.领取VRP')}</span></button>
                    </div>
                    
                </div>


                <div className='w-full px-4 mt-6 flex flex-row justify-between items-center'>
                    <span className='text-white text-sm'>{t('mint.当前期数')}：2</span>
                    <span className='text-[#E94B6C] text-sm font-bold'>BNB chain main</span>
                </div>

                {/*  */}
                <div className='  mt-2 mb-9 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>


                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.我已认购金额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{usdtAmount2} USDT</span>
                           
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.退USDT数量')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{backUNum2} USDT</span>
                           
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.可领取代币数量')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{getTNum2} VRP</span>
                           
                        </div>
                    </div>
                   
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>
                    
                    
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_randUsdt2}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.领取退U')}</span></button>
                    </div>

                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_randT2}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.领取VRP')}</span></button>
                    </div>
                    
                </div>



                <div className='w-full px-4 mt-6 flex flex-row justify-between items-center'>
                    <span className='text-white text-sm'>{t('mint.当前期数')}：3</span>
                    <span className='text-[#E94B6C] text-sm font-bold'>BNB chain main</span>
                </div>

                {/*  */}
                <div className='  mt-2 mb-9 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>


                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.我已认购金额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{usdtAmount3} USDT</span>
                           
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.退USDT数量')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{backUNum3} USDT</span>
                           
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.可领取代币数量')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{getTNum3} VRP</span>
                           
                        </div>
                    </div>
                   
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>
                    
                    
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_randUsdt3}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.领取退U')}</span></button>
                    </div>

                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_randT3}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.领取VRP')}</span></button>
                    </div>
                    
                </div>

              

                

                </main>
                
            </div>
            

                
           {/* <Foot/> */}
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(AfterSale);
